import { render } from "./VehiclesCards.vue?vue&type=template&id=1189507f"
import script from "./VehiclesCards.vue?vue&type=script&lang=js"
export * from "./VehiclesCards.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Mori\\Desktop\\aptopler-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__